import React from 'react';
import { Link } from 'react-router-dom';
import { Lightning, EnvelopeSimple, MapPin, Phone } from '@phosphor-icons/react';

const companyLinks = [
  { label: 'About', path: '/about' },
  { label: 'Products', path: '/products' },
  { label: 'Services', path: '/services' },
  { label: 'Contact us', path: '/contact' },
];

const servicesLinks = [
  { label: 'Agentic AI', path: '/services/agentic-ai' },
  { label: 'DevOps Automation', path: '/services/devops-automation' },
  { label: 'Cloud & FinOps', path: '/services/cloud-finops' },
  { label: 'Infrastructure & Compute', path: '/services/infrastructure-compute' },
];

const resourcesLinks = [
  { label: 'Privacy Policy', path: '/privacy-policy' },
  { label: 'Terms & Conditions', path: '/terms-and-conditions' },
  { label: 'Refund Policy', path: '/refund-policy' },
];

const ftStyle = { margin: 0, fontFamily: 'Roboto, sans-serif', fontWeight: 400, fontSize: '24px', lineHeight: 1.43 };
const ftHeadStyle = { margin: 0, fontFamily: 'Roboto, sans-serif', fontWeight: 600, fontSize: '24px', lineHeight: 1.43 };

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-slate-300" data-testid="footer">
      {/* CTA Banner */}
      <div className="bg-gradient-to-r from-[#0052FF] to-[#0040CC] py-16">
        <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24 text-center">
          <h3
            className="text-2xl sm:text-3xl font-bold text-white mb-4"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            Ready to get started?
          </h3>
          <p className="text-[16px] text-white/80 mb-8 max-w-2xl mx-auto" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            See what your team can do with the most comprehensive AI-powered DevSecOps and Cloud Infrastructure platform.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-3.5 bg-white text-[#0052FF] text-[15px] font-bold rounded-full hover:bg-slate-100 transition-colors duration-200"
            data-testid="cta-book-meeting-btn"
          >
            BOOK A MEETING
          </Link>
        </div>
      </div>

      {/* Footer content */}
      <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12">
          {/* Logo */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-white mb-4">
              <Lightning size={28} weight="fill" className="text-[#0052FF]" />
              <span className="font-black text-xl tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
                AIAURORA<span className="text-[#10B981]">.</span>
              </span>
            </Link>
          </div>

          {/* Company */}
          <div>
            <h4 style={ftHeadStyle} className="text-white mb-5">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} style={ftStyle} className="text-slate-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Offer */}
          <div>
            <h4 style={ftHeadStyle} className="text-white mb-5">Services Offer</h4>
            <ul className="space-y-3">
              {servicesLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} style={ftStyle} className="text-slate-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 style={ftHeadStyle} className="text-white mb-5">Resources</h4>
            <ul className="space-y-3">
              {resourcesLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} style={ftStyle} className="text-slate-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <EnvelopeSimple size={18} weight="bold" className="text-[#0052FF] mt-0.5 flex-shrink-0" />
                <span style={{ ...ftStyle, fontSize: '16px', wordBreak: 'break-all' }} className="text-slate-400">aiauroratechprivatelimited@gmail.com</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} weight="bold" className="text-[#0052FF] mt-0.5 flex-shrink-0" />
                <div>
                  <p style={ftHeadStyle} className="text-slate-200">United States</p>
                  <p style={ftStyle} className="text-slate-400">7901 4th Street NORTH STE 300, ST. PETERSBURG, FL. 33702</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} weight="bold" className="text-[#0052FF] mt-0.5 flex-shrink-0" />
                <div>
                  <p style={ftHeadStyle} className="text-slate-200">India</p>
                  <p style={ftStyle} className="text-slate-400">509, Titannium Business Hub, Althan, Surat, Gujarat-395007</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#1E293B]">
        <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24 py-5 text-center">
          <p style={ftStyle} className="text-slate-500">
            &copy; {new Date().getFullYear()} AIAURORA TECH INC. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
